<template>
    <div class="widget tables vacancies">
        <div class="table-header">
                <div class="table-title">Shortlists</div>
            </div>
        <div class="table-content"> 
               <div class="table-tools" style="display:flex;justify-content: space-between;align-items:center;">
                <div class="table-actions">
                    <button type="button" class="search-btn" @click="search">
                        <img class="table-icon" src="../../assets/icons/search.svg"/>
                    </button>
                    <input type="text" class="search-query" v-model="searchQuery" placeholder="Search Shortlisted" @keydown.enter.prevent>
                </div>  
                    <button class="" style="color:white;border:0px;border-radius:100px;margin-top:0.4rem;padding:0.3rem 0.7rem;background:var(--del-gradient);"><img style="height:0.9rem;margin-top:-0.3rem;margin-right:0.1rem;" src="../../assets/icons/trash-3.svg"/> <span style="font-size:0.9rem;">Delete All</span></button>
            </div>
            <table id="myTable" class="display">
                <thead>
                    <tr>
                        <th>Candidate</th>
                        <th>Job Title</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- item -->
                     <tr>
                        <td title="Candidate Name"><div class="row-context">Helix Chipofya</div></td>
                        <td title="Job Title">General Manager</td> 
                        <td class="row-actions">
                            
                        </td> 
                        <td>
                            <div class="icon-buttons">

                                <button title="Revoke Candidate" class="icon-button"><img class="icon-button-icon" src="../../assets/icons/x-circle.svg" /></button>
                                <button title="Delete Candidate" class="icon-button"><img class="icon-button-icon" src="../../assets/icons/trash-2.svg" /></button>
                            </div>
                        </td>
                    </tr>

                   
                    <!--  -->

                </tbody>
            </table>
                <div class="custom-pagination" v-show="totalPages > 0">
                    <button class="pager-btn" :disabled="currentPage === 0" @click="prevPage">Prev</button>
                    <button v-for="p in pagerPages" :key="p" class="pager-btn" :class="{current: p===currentPage}"
                        @click="goToPage(p)">{{ p+1 }}</button>
                    <button class="pager-btn" :disabled="currentPage === totalPages-1" @click="nextPage">Next</button>
                </div>
        </div>
    </div>
</template>
<script>
import DataTable from 'datatables.net-dt';
export default {
    data() {
        return {
            searchQuery: '',
            table: null,
            currentPage: 0,
            totalPages: 0,
            pagerPages: [],
            pageSize: 10,
            totalRecords: 0
        };
    },
    mounted(){
        this.table = new DataTable('#myTable', {
                       dom: 'rt',
                       scrollY: 300,
                       scrollCollapse: false,
                       ordering: false,
                       paging: false,
                       searching: false,
            });
    },
    methods: {
        search() {
            // intentionally no-op: table will not be auto-filled
            return;
        }
        ,
        updatePager() {
            const maxButtons = 7;
            let start = Math.max(0, this.currentPage - Math.floor(maxButtons/2));
            let end = start + maxButtons - 1;
            if (end > this.totalPages - 1) {
                end = this.totalPages - 1;
                start = Math.max(0, end - (maxButtons - 1));
            }
            const pages = [];
            for (let i = start; i <= end; i++) pages.push(i);
            this.pagerPages = pages;
        },
        goToPage(page) {
            if (page < 0 || page >= this.totalPages) return;
            this.loadPage(page);
        },
        prevPage() {
            this.goToPage(this.currentPage - 1);
        },
        nextPage() {
            this.goToPage(this.currentPage + 1);
        }
        ,
        async loadPage(page) {
            const pageSize = this.pageSize;
            this.currentPage = page;
            const q = this.searchQuery && this.searchQuery.trim() ? this.searchQuery.trim() : '';
            // try API endpoint first
            try {
                const res = await fetch(`/api/vacancies?page=${page+1}&pageSize=${pageSize}&q=${encodeURIComponent(q)}`);
                if (res.ok) {
                    const json = await res.json();
                    const items = json.items || [];
                    const total = typeof json.total === 'number' ? json.total : items.length;
                    this.totalRecords = total;
                    this.totalPages = Math.max(1, Math.ceil(total / pageSize));
                    // map items to rows matching columns (Column1 = jobRole, Column2 = companyName)
                    const rows = items.map(it => [it.jobRole || '', it.companyName || '']);
                    this.table.clear();
                    this.table.rows.add(rows);
                    this.table.draw(false);
                    this.updatePager();
                    return;
                }
            } catch (e) {
                // fallthrough to local fallback
            }
            // fallback: load local assets/jobs.json and simulate pagination
            try {
                const resp = await fetch(new URL('../../assets/jobs.json', import.meta.url));
                const all = await resp.json();
                const filtered = q ? all.filter(it => (it.jobRole || '').toLowerCase().includes(q.toLowerCase()) || (it.companyName || '').toLowerCase().includes(q.toLowerCase())) : all;
                const total = filtered.length;
                this.totalRecords = total;
                this.totalPages = Math.max(1, Math.ceil(total / pageSize));
                const start = page * pageSize;
                const pageItems = filtered.slice(start, start + pageSize);
                const rows = pageItems.map(it => [it.jobRole || '', it.companyName || '']);
                this.table.clear();
                this.table.rows.add(rows);
                this.table.draw(false);
                this.updatePager();
            } catch (e) {
                console.error('Failed to load vacancies for pagination', e);
            }
        }
    }
}
</script>
<style scoped>

 

    .icon-button-icon{
        height:1rem;
    }
    .icon-buttons{
        display: flex;
        justify-content: right;
    }
    .icon-button{
        border:0px;
        background: transparent;
    }

    .badge-btn{
        font-size:0.8rem;
        border-radius: 100px;
        border:0px;
    }

    .badge-btn:first-child{
        margin-right:0.4rem;
        background-color: rgb(20, 138, 20);
    }

    .badge-btn:last-child{
        background: var(--gradient)
    }
    .badge{
        color:black;
        background: white;
        margin-left:0.3rem;
        border-radius: 100px;
    }
    th{
        font-weight: normal!important;
    }


    .row-context{
        white-space: nowrap;
        overflow-x: hidden;
        max-width:14rem;
        min-width:10rem;
        text-overflow: ellipsis;
        /* border:1px solid black; */
    }
/* Datatable base */
.table-content {
    overflow-x: auto;
}

#myTable {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--font-family, Arial, Helvetica, sans-serif);
    font-size: 14px;
    color: var(--text-color, #222);
}

#myTable thead th {
    text-align: left;
    padding: 10px 12px;
    background: var(--table-header-bg, #f7f8fa);
    color: var(--table-header-color, #111);
    border-bottom: 1px solid rgba(0,0,0,0.08);
    position: sticky;
    top: 0;
    z-index: 2;
}

#myTable tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(0,0,0,0.04);
    vertical-align: middle;
}

/* Row hover and stripe */
#myTable tbody tr:nth-child(odd) {
    background: var(--table-row-odd, #fff);
}
#myTable tbody tr:nth-child(even) {
    background: var(--table-row-even, #fbfbfb);
}
#myTable tbody tr:hover {
    background: rgba(0,0,0,0.03);
}

/* Small utilities */
/* .table-header {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 8px;
} */

.table-header {
    display: grid;
}
.table-title {
    font-weight: 600;
    font-size: 18px;
}

.search-query{
    border:1px solid rgb(162, 161, 161)!important;
    border-radius:100px!important;
    font-size:0.9rem;
}
.table-actions {
    margin-top:0.5rem;
    display: flex;

}
.table-actions input[type="text"] {
    height: 36px;
    padding: 6px 10px;
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 6px;
    min-width: 180px;
}
.table-actions .search-btn {
    font-size:0.9rem;
    border-radius: 6px;
    border:0px;
    border-radius: 100px;
    background: var(--gradient);
    margin-right:0.5rem;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0.5rem 0.6rem;
}

.table-icon{
    
    height:1.2rem;
}
/* .table-actions .search-btn:active {
    transform: translateY(1px);
} */

/* DataTables wrapper compat (pagination, info, filters) */
.dataTables_wrapper .dataTables_paginate a,
.dataTables_wrapper .dataTables_paginate span {
    display: inline-block;
    padding: 6px 10px;
    margin: 0 4px;
    border-radius: 4px;
    background: transparent;
    color: var(--primary-color, #007bff);
    cursor: pointer;
}
.dataTables_wrapper .dataTables_paginate .current {
    background: var(--primary-color, #007bff);
    color: #fff;
}

/* Modern paginate buttons */
.dataTables_wrapper .dataTables_paginate .paginate_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    margin: 0 6px;
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.06);
    background: #fff;
    color: var(--primary-color, #007bff);
    box-shadow: 0 1px 0 rgba(0,0,0,0.02);
    transition: background .12s, transform .08s, color .12s;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.current {
    background: var(--primary-color, #007bff);
    color: #fff;
    border-color: var(--primary-color, #007bff);
}
.dataTables_wrapper .dataTables_paginate .paginate_button:not(.current):hover:not(.disabled) {
    background: rgba(0,123,255,0.06);
    transform: translateY(-1px);
}
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
    opacity: 0.5;
    cursor: default;
    transform: none;
}

/* Add subtle arrow affordances while keeping text visible */
.dataTables_wrapper .dataTables_paginate .previous::before {
    content: "◀ ";
    opacity: 0.85;
}
.dataTables_wrapper .dataTables_paginate .next::after {
    content: " ▶";
    opacity: 0.85;
}

/* hide default DataTables pagination since we use custom pager */
.dataTables_wrapper .dataTables_paginate {
    display: none !important;
}

.custom-pagination {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-top: 12px;
}
.pager-btn {
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.06);
    background: #fff;
    color: var(--primary, var(--primary-color, #007bff));
    cursor: pointer;
}
.pager-btn.current {
    background: var(--primary, var(--primary-color, #007bff));
    color: #fff;
    border-color: var(--primary, var(--primary-color, #007bff));
}
.pager-btn:disabled {
    opacity: 0.5;
    cursor: default;
}

/* Responsive: shrink padding on very small screens */
@media (max-width: 520px) {
    #myTable thead th,
    #myTable tbody td {
        padding: 8px 6px;
        font-size: 13px;
    }
}
</style>

/* Global rules -- must be non-scoped so they apply to DataTables-injected elements */
<style>
/* Hide default DataTables pagination wrapper (we use custom pagination) */
.dataTables_wrapper .dataTables_paginate {
    display: none !important;
}
</style>